// Route 53 hosted zone for custom domains (`<stage>.gmi-character-playground.exp.monks.zone`).
// The zone was created for us in this AWS account (ID Z0682901KO5SKDPG6L2O) and is already
// delegated from the parent `exp.monks.zone` - we only attach records to it, we never create it.
// Single source of truth - used by the StaticSite domain (site.ts) and the API domain (gateway.ts).
export const HOSTED_ZONE_NAME = 'gmi-character-playground.exp.monks.zone'

export interface SettingsTemplate {
  // Deployment flags
  DEPLOY_STORYBOOK: boolean

  // Environment detection
  isLocal: boolean
  isProdDeploy: boolean

  // Feature flags
  ENABLE_METRICS: boolean

  // CORS
  API_CORS_ALLOW_ORIGIN: string

  // Optional ComfyUI/EC2 Playground character path. This infrastructure is
  // independent from Workflow V2, which is always serverless/Gemini-only.
  COMFYUI_AUTO_SHUTDOWN_IDLE_HOURS: number
  COMFYUI_USE_SPOT_INSTANCE: boolean
  COMFYUI_SPOT_MAX_PRICE: string
  DEPLOY_COMFYUI_EC2: boolean
  ENABLE_EC2_PLAYGROUND: boolean

  // Attach custom domains to the stage:
  //   frontend: `<stage>.${HOSTED_ZONE_NAME}` (CloudFront)
  //   api:      `api.<stage>.${HOSTED_ZONE_NAME}` (API Gateway)
  //   storybook: `storybook.<stage>.${HOSTED_ZONE_NAME}` (CloudFront; dev only)
  // SST looks up the hosted zone by name and provisions ACM certs + alias records automatically.
  // Keep false for local/personal stacks so they don't fight over the same domain names
  // (exception: the `ale` stage - see applyPersonalStageOverrides in settings/index.ts).
  ENABLE_CUSTOM_DOMAIN: boolean
}

export const settingsTemplate: SettingsTemplate = {
  DEPLOY_STORYBOOK: false,

  isLocal: false,
  isProdDeploy: false,

  ENABLE_METRICS: true,

  API_CORS_ALLOW_ORIGIN: '*',

  COMFYUI_AUTO_SHUTDOWN_IDLE_HOURS: 3,
  COMFYUI_USE_SPOT_INSTANCE: false,
  COMFYUI_SPOT_MAX_PRICE: '',
  DEPLOY_COMFYUI_EC2: false,
  ENABLE_EC2_PLAYGROUND: false,

  ENABLE_CUSTOM_DOMAIN: false
}
